import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

import { Config, isWidget, LegacyCityPropType } from '@ratehub/base-ui';
import { LandTransferTaxCalculator } from '@ratehub/calculators';

import PAGE_TEMPLATES from '../definitions/PageTemplates';
import AdvertisingDisclosure from './AdvertisingDisclosure';
import MortgageSaveToProfileContainer from './MortgageSaveToProfileContainer';


const DATA_NAME_SAVE_TO_PROFILE = 'mtg-ltt-SaveToProfile';

function MortgageLandTransferTaxCalculator({ initialProvinceCode, initialCity, showAdDisclosure, className, ...otherProps }) {
    const shouldShowSaveToProfileButton = Config.ENABLE_SAVE_TO_PROFILE_BUTTON && !isWidget();

    return (
        <section
            className={classNames(
                'rh-max-width-75',
                'rh-pt-0_5',
                className,
            )}
        >
            <If condition={shouldShowSaveToProfileButton}>
                <MortgageSaveToProfileContainer dataName={DATA_NAME_SAVE_TO_PROFILE} />
            </If>

            <LandTransferTaxCalculator
                className={classNames(
                    'rh-my-0',
                    'rh-mx-auto',
                )}
                initialProvinceCode={initialProvinceCode}
                initialCity={initialCity}
                {...otherProps}
            />

            <If condition={showAdDisclosure}>
                <StyledDiv
                    className={classNames(
                        'rh-my-1',
                        'rh-mx-0_5',
                    )}
                >
                    <AdvertisingDisclosure
                        size="extra-small"
                    />
                </StyledDiv>
            </If>

            <If condition={shouldShowSaveToProfileButton}>
                <MortgageSaveToProfileContainer dataName={DATA_NAME_SAVE_TO_PROFILE} />
            </If>
        </section>
    );
}

MortgageLandTransferTaxCalculator.propTypes = {
    initialProvinceCode: PropTypes.string,
    initialCity: LegacyCityPropType,
    showAdDisclosure: PropTypes.bool,
    className: PropTypes.string,
};

MortgageLandTransferTaxCalculator.defaultProps = {
    initialProvinceCode: undefined,
    initialCity: undefined,
    showAdDisclosure: true,
    className: undefined,
};

const StyledDiv = styled.div`
    display: flex;
    justify-content: flex-end;
`;

MortgageLandTransferTaxCalculator.blockKey = 'rh/mortgage-land-transfer-tax-calculator';
MortgageLandTransferTaxCalculator.requiresLayoutRow = true;
MortgageLandTransferTaxCalculator.supportedPageTypes = [ PAGE_TEMPLATES.calculatorsMtg ];

export default MortgageLandTransferTaxCalculator;
